/* eslint-disable no-console */

import { register } from 'register-service-worker'

const isRedirectedByMallH5 =
  [
    'wxtest.yunshanmeicai.com',
    'mallh5.stage.yunshanmeicai.com',
    'online.yunshanmeicai.com',
    'wxtest.linmontop.com.cn',
    'mallh5.stage.linmontop.com.cn',
    'online.linmontop.com.cn'
  ].indexOf(window.location.hostname) > -1

if (process.env.NODE_ENV === 'production' && !isRedirectedByMallH5) {
  register(`${window.location.origin}/service-worker.js`, {
    // register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available; Refresh...')
      setTimeout(() => {
        window.location.reload(true)
      }, 1000)
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
